export class TextTypeDto {
  constructor(
    public id: number,
    public name: string,
    public modes: string[],
    public domains: string[],
    public interactions: string[],
    public media: string[],
    public representations: string[],
    public purpose: string[],
    public vocabCategoryIds: number[],
    public vocabEntryIds: number[],
    public functionalGrammarCategoryIds: number[],
    public functionalGrammarEntryIds: number[],
    public systemicGrammarCategoryIds: number[],
    public systemicGrammarEntryIds: number[],
    public textPatternIds: number[],
    public textTypeIds: number[],
    public detailedCanDoStatementCategoryIds: number[],
    public detailedCanDoStatementEntryIds: number[],
    public globalCanDoStatementCategoryIds: number[],
    public globalCanDoStatementEntryIds: number[]
  ) {
  }
}
